import { defineStore } from 'pinia';
import { MainRoles } from '../types/security/roles';
import { useStateStore } from './state';
import { enFetch } from 'Js/utils/enFetch';
import { RequestMethods } from 'Js/types/fetch/requestMethod';
import { useUserSettingsStore } from 'Js/store/useUserSettingsStore';
/**
 * Store of current logged in user.
 */
export const useAuthStore = defineStore('auth', {
    state: () => ({
        me: null,
        loaded: false,
    }),
    /**
     * Defines different accesses of user
     */
    getters: {
        roles: (s) => s.me?.roles ?? [],
        isGlobalAdmin: (s) => s.me?.Roles?.includes(MainRoles.GlobalAdmin),
        isEnPowerUser: (s) => s.me?.Roles?.includes(MainRoles.EnPowerUser),
        permissions: (s) => s.me?.Permissions ?? [],
        modulePermissions: (s) => s.me?.Permissions ?? [],
        hasRole: (s) => (role) => (s.me?.Roles ?? []).includes(role),
        can: (s) => (perm) => s.isGlobalAdmin || (s.me?.Permissions ?? []).includes(perm),
        canAny: (s) => (perms) => perms.some(p => (s.me?.Permissions ?? []).includes(p)),
        canAll: (s) => (perms) => perms.every(p => (s.me?.Permissions ?? []).includes(p)),
    },
    actions: {
        async syncUser() {
            const stateStore = useStateStore();
            this.me = stateStore.globalState?.User ?? await this.loadUser();
            const { updateState } = useUserSettingsStore();
            updateState({ User: this.me, IsGlobalAdmin: this.isGlobalAdmin });
            this.loaded = true;
        },
        async loadUser() {
            try {
                const config = await enFetch('/api/Configuration/GetUserInfo', {
                    method: RequestMethods.Get,
                });
                return config;
            }
            catch {
                return null;
            }
        },
        logout() {
            this.me = null;
            this.loaded = true;
        },
    },
});
